import { ModalAction, ModalActionTypes, ModalState } from './types';

export const modalReducer = (state: ModalState = null, action: ModalAction) => {
  switch (action.type) {
    case ModalActionTypes.SHOW:
      return {
        type: action.modalType,
        props: action.props,
      };
    case ModalActionTypes.DISMISS:
      if (state !== null) {
        return null;
      }
  }

  return state;
};
